import React, { useState, useEffect } from 'react';
import { Input, DatePicker, message, Button, Spin } from 'antd';
import dayjs from 'dayjs';
import { useLocation } from 'react-router-dom';
import {
    getTasksForType,
} from './taskConstants';
import { Link } from 'react-router-dom';
import Sidebar from '../Components/SideBar';
import { buildApiUrl } from '../utils/api';

const TASK_DURATIONS = {
    rooftop: {
        india: {
            // Old "1" => new "2.0"
            "1.0": { duration: 15 },
            "1.1": { duration: 5 },
            "1.2": { duration: 5 },
            "1.3": { duration: 5 },

            // Old "2" => new "3.0"
            "2.0": { duration: 15 },
            "2.1": { duration: 3 },
            "2.2": { duration: 5 },
            "2.3": { duration: 2 },
            "2.4": { duration: 5 },

            // Old "3" => new "4.0"
            "3.0": { duration: 17 },
            "3.1": { duration: 10 },
            "3.2": { duration: 7 },
            "3.3": { duration: 7 },
            "3.4": { duration: 7 },
            "3.5": { duration: 7 },
            "3.6": { duration: 7 },
            "3.7": { duration: 7 },
            "3.8": { duration: 7 },
            "3.9": { duration: 7 },
            "3.10": { duration: 7 },
            "3.11": { duration: 7 },
            "3.12": { duration: 7 },

            // Old "4" => new "5.0"
            "4.0": { duration: 45 },
            "4.1": { duration: 35 },
            "4.2": { duration: 35 },
            "4.3": { duration: 35 },
            "4.4": { duration: 45 },
            "4.5": { duration: 30 },
            "4.6": { duration: 20 },
            "4.7": { duration: 30 },
            "4.8": { duration: 30 },
            "4.9": { duration: 25 },
            "4.10": { duration: 30 },
            "4.11": { duration: 30 },
            "4.12": { duration: 25 },

            // Old "5" => new "6.0"
            "5.0": { duration: 64 },
            "5.1": { duration: 5 },
            "5.2": { duration: 5 },
            "5.3": { duration: 5 },
            "5.4": { duration: 20 },
            "5.5": { duration: 10 },
            "5.6": { duration: 5 },
            "5.7": { duration: 20 },
            "5.8": { duration: 10 },
            "5.9": { duration: 20 },
            "5.10": { duration: 10 },
            "5.11": { duration: 5 },
            "5.12": { duration: 8 },
            "5.13": { duration: 10 },
            "5.14": { duration: 15 },
            "5.15": { duration: 10 },
            "5.16": { duration: 5 },
            "5.17": { duration: 5 },
            "5.18": { duration: 5 },
            "5.19": { duration: 2 },
            "5.20": { duration: 5 },

            // Old "6" => new "7.0"
            "6.0": { duration: 123 },
            "6.1": { duration: 10 },
            "6.2": { duration: 10 },
            "6.3": { duration: 15 },
            "6.4": { duration: 5 },
            "6.5": { duration: 7 },
            "6.6": { duration: 7 },

            // Old "7" => new "8.0"
            "7.0": { duration: 129 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 10 },
            "7.4": { duration: 5 },
            "7.5": { duration: 5 },
            "7.6": { duration: 20 },
            "7.7": { duration: 30 },
            "7.8": { duration: 5 },
            "7.9": { duration: 5 },
            "7.10": { duration: 5 },
            "7.11": { duration: 5 },

            // Old "8" => new "9.0"
            "8.0": { duration: 32 },
            "8.1": { duration: 2 },
            "8.2": { duration: 2 },
            "8.3": { duration: 20 },
            "8.4": { duration: 5 },
            "8.5": { duration: 7 },
            "8.6": { duration: 2 }
        }
    },

    groundmount: {
        india: {
            "1.0": { duration: 1 },
            "1.1": { duration: 2 },
            "1.2": { duration: 2 },
            "1.3": { duration: 5 },
            "1.4": { duration: 5 },
            "1.5": { duration: 5 },
            "1.6": { duration: 3 },

            // Design & Engineering
            "2.0": { duration: 3 },
            "2.1": { duration: 3 },
            "2.2": { duration: 3 },
            "2.3": { duration: 3 },
            "2.4": { duration: 3 },
            "2.5": { duration: 5 },
            "2.6": { duration: 2 },

            // Statutory Approvals
            "3.0": { duration: 10 },
            "3.1": { duration: 10 },
            "3.2": { duration: 10 },
            "3.3": { duration: 10 },
            "3.4": { duration: 15 },
            "3.5": { duration: 10 },
            "3.6": { duration: 15 },

            // Procurement
            "4.0": { duration: 10 },
            "4.1": { duration: 5 },
            "4.2": { duration: 20 },
            "4.3": { duration: 30 },
            "4.4": { duration: 25 },
            "4.5": { duration: 20 },
            "4.6": { duration: 20 },

            // Site Mobilization
            "5.0": { duration: 2 },
            "5.1": { duration: 2 },
            "5.2": { duration: 2 },
            "5.3": { duration: 2 },

            // Civil Works
            "6.0": { duration: 4 },
            "6.1": { duration: 4 },
            "6.2": { duration: 4 },
            "6.3": { duration: 4 },
            "6.4": { duration: 4 },

            // Mounting Structure Installation
            "7.0": { duration: 3 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 5 },

            // Module Installation
            "8.0": { duration: 3 },
            "8.1": { duration: 10 },
            "8.2": { duration: 5 },
            "8.3": { duration: 3 },

            // DC Cabling & String Formation
            "9.0": { duration: 5 },
            "9.1": { duration: 3 },
            "9.2": { duration: 3 },
            "9.3": { duration: 3 },

            // Inverter and AC Works
            "10.0": { duration: 5 },
            "10.1": { duration: 5 },
            "10.2": { duration: 3 },
            "10.3": { duration: 5 },
            "10.4": { duration: 5 },

            // SCADA and Communication
            "11.0": { duration: 3 },
            "11.1": { duration: 3 },
            "11.2": { duration: 3 },
            "11.3": { duration: 3 },

            // Testing & Commissioning
            "12.0": { duration: 5 },
            "12.1": { duration: 5 },
            "12.2": { duration: 2 },
            "12.3": { duration: 3 },

            // Handover & Documentation
            "13.0": { duration: 3 },
            "13.1": { duration: 3 },
            "13.2": { duration: 3 },
            "13.3": { duration: 1 }
        },
        dubai: {
            "1.0": { duration: 1 },
            "1.1": { duration: 2 },
            "1.2": { duration: 2 },
            "1.3": { duration: 5 },
            "1.4": { duration: 5 },
            "1.5": { duration: 5 },
            "1.6": { duration: 3 },

            // Design & Engineering
            "2.0": { duration: 3 },
            "2.1": { duration: 3 },
            "2.2": { duration: 3 },
            "2.3": { duration: 3 },
            "2.4": { duration: 3 },
            "2.5": { duration: 5 },
            "2.6": { duration: 2 },

            // Statutory Approvals
            "3.0": { duration: 10 },
            "3.1": { duration: 10 },
            "3.2": { duration: 10 },
            "3.3": { duration: 10 },
            "3.4": { duration: 15 },
            "3.5": { duration: 10 },
            "3.6": { duration: 15 },

            // Procurement
            "4.0": { duration: 10 },
            "4.1": { duration: 5 },
            "4.2": { duration: 20 },
            "4.3": { duration: 30 },
            "4.4": { duration: 25 },
            "4.5": { duration: 20 },
            "4.6": { duration: 20 },

            // Site Mobilization
            "5.0": { duration: 2 },
            "5.1": { duration: 2 },
            "5.2": { duration: 2 },
            "5.3": { duration: 2 },

            // Civil Works
            "6.0": { duration: 4 },
            "6.1": { duration: 4 },
            "6.2": { duration: 4 },
            "6.3": { duration: 4 },
            "6.4": { duration: 4 },

            // Mounting Structure Installation
            "7.0": { duration: 3 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 5 },

            // Module Installation
            "8.0": { duration: 3 },
            "8.1": { duration: 10 },
            "8.2": { duration: 5 },
            "8.3": { duration: 3 },

            // DC Cabling & String Formation
            "9.0": { duration: 5 },
            "9.1": { duration: 3 },
            "9.2": { duration: 3 },
            "9.3": { duration: 3 },

            // Inverter and AC Works
            "10.0": { duration: 5 },
            "10.1": { duration: 5 },
            "10.2": { duration: 3 },
            "10.3": { duration: 5 },
            "10.4": { duration: 5 },

            // SCADA and Communication
            "11.0": { duration: 3 },
            "11.1": { duration: 3 },
            "11.2": { duration: 3 },
            "11.3": { duration: 3 },

            // Testing & Commissioning
            "12.0": { duration: 5 },
            "12.1": { duration: 5 },
            "12.2": { duration: 2 },
            "12.3": { duration: 3 },

            // Handover & Documentation
            "13.0": { duration: 3 },
            "13.1": { duration: 3 },
            "13.2": { duration: 3 },
            "13.3": { duration: 1 }
        },
        tanzania: {
            "1.0": { duration: 1 },
            "1.1": { duration: 2 },
            "1.2": { duration: 2 },
            "1.3": { duration: 5 },
            "1.4": { duration: 5 },
            "1.5": { duration: 5 },
            "1.6": { duration: 3 },

            // Design & Engineering
            "2.0": { duration: 3 },
            "2.1": { duration: 3 },
            "2.2": { duration: 3 },
            "2.3": { duration: 3 },
            "2.4": { duration: 3 },
            "2.5": { duration: 5 },
            "2.6": { duration: 2 },

            // Statutory Approvals
            "3.0": { duration: 10 },
            "3.1": { duration: 10 },
            "3.2": { duration: 10 },
            "3.3": { duration: 10 },
            "3.4": { duration: 15 },
            "3.5": { duration: 10 },
            "3.6": { duration: 15 },

            // Procurement
            "4.0": { duration: 10 },
            "4.1": { duration: 5 },
            "4.2": { duration: 20 },
            "4.3": { duration: 30 },
            "4.4": { duration: 25 },
            "4.5": { duration: 20 },
            "4.6": { duration: 20 },

            // Site Mobilization
            "5.0": { duration: 2 },
            "5.1": { duration: 2 },
            "5.2": { duration: 2 },
            "5.3": { duration: 2 },

            // Civil Works
            "6.0": { duration: 4 },
            "6.1": { duration: 4 },
            "6.2": { duration: 4 },
            "6.3": { duration: 4 },
            "6.4": { duration: 4 },

            // Mounting Structure Installation
            "7.0": { duration: 3 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 5 },

            // Module Installation
            "8.0": { duration: 3 },
            "8.1": { duration: 10 },
            "8.2": { duration: 5 },
            "8.3": { duration: 3 },

            // DC Cabling & String Formation
            "9.0": { duration: 5 },
            "9.1": { duration: 3 },
            "9.2": { duration: 3 },
            "9.3": { duration: 3 },

            // Inverter and AC Works
            "10.0": { duration: 5 },
            "10.1": { duration: 5 },
            "10.2": { duration: 3 },
            "10.3": { duration: 5 },
            "10.4": { duration: 5 },

            // SCADA and Communication
            "11.0": { duration: 3 },
            "11.1": { duration: 3 },
            "11.2": { duration: 3 },
            "11.3": { duration: 3 },

            // Testing & Commissioning
            "12.0": { duration: 5 },
            "12.1": { duration: 5 },
            "12.2": { duration: 2 },
            "12.3": { duration: 3 },

            // Handover & Documentation
            "13.0": { duration: 3 },
            "13.1": { duration: 3 },
            "13.2": { duration: 3 },
            "13.3": { duration: 1 }
        },
        kenya: {
            "1.0": { duration: 1 },
            "1.1": { duration: 2 },
            "1.2": { duration: 2 },
            "1.3": { duration: 5 },
            "1.4": { duration: 5 },
            "1.5": { duration: 5 },
            "1.6": { duration: 3 },

            // Design & Engineering
            "2.0": { duration: 3 },
            "2.1": { duration: 3 },
            "2.2": { duration: 3 },
            "2.3": { duration: 3 },
            "2.4": { duration: 3 },
            "2.5": { duration: 5 },
            "2.6": { duration: 2 },

            // Statutory Approvals
            "3.0": { duration: 10 },
            "3.1": { duration: 10 },
            "3.2": { duration: 10 },
            "3.3": { duration: 10 },
            "3.4": { duration: 15 },
            "3.5": { duration: 10 },
            "3.6": { duration: 15 },

            // Procurement
            "4.0": { duration: 10 },
            "4.1": { duration: 5 },
            "4.2": { duration: 20 },
            "4.3": { duration: 30 },
            "4.4": { duration: 25 },
            "4.5": { duration: 20 },
            "4.6": { duration: 20 },

            // Site Mobilization
            "5.0": { duration: 2 },
            "5.1": { duration: 2 },
            "5.2": { duration: 2 },
            "5.3": { duration: 2 },

            // Civil Works
            "6.0": { duration: 4 },
            "6.1": { duration: 4 },
            "6.2": { duration: 4 },
            "6.3": { duration: 4 },
            "6.4": { duration: 4 },

            // Mounting Structure Installation
            "7.0": { duration: 3 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 5 },

            // Module Installation
            "8.0": { duration: 3 },
            "8.1": { duration: 10 },
            "8.2": { duration: 5 },
            "8.3": { duration: 3 },

            // DC Cabling & String Formation
            "9.0": { duration: 5 },
            "9.1": { duration: 3 },
            "9.2": { duration: 3 },
            "9.3": { duration: 3 },

            // Inverter and AC Works
            "10.0": { duration: 5 },
            "10.1": { duration: 5 },
            "10.2": { duration: 3 },
            "10.3": { duration: 5 },
            "10.4": { duration: 5 },

            // SCADA and Communication
            "11.0": { duration: 3 },
            "11.1": { duration: 3 },
            "11.2": { duration: 3 },
            "11.3": { duration: 3 },

            // Testing & Commissioning
            "12.0": { duration: 5 },
            "12.1": { duration: 5 },
            "12.2": { duration: 2 },
            "12.3": { duration: 3 },

            // Handover & Documentation
            "13.0": { duration: 3 },
            "13.1": { duration: 3 },
            "13.2": { duration: 3 },
            "13.3": { duration: 1 }
        },

        botswana: {
            "1.0": { duration: 1 },
            "1.1": { duration: 2 },
            "1.2": { duration: 2 },
            "1.3": { duration: 5 },
            "1.4": { duration: 5 },
            "1.5": { duration: 5 },
            "1.6": { duration: 3 },

            // Design & Engineering
            "2.0": { duration: 3 },
            "2.1": { duration: 3 },
            "2.2": { duration: 3 },
            "2.3": { duration: 3 },
            "2.4": { duration: 3 },
            "2.5": { duration: 5 },
            "2.6": { duration: 2 },

            // Statutory Approvals
            "3.0": { duration: 10 },
            "3.1": { duration: 10 },
            "3.2": { duration: 10 },
            "3.3": { duration: 10 },
            "3.4": { duration: 15 },
            "3.5": { duration: 10 },
            "3.6": { duration: 15 },

            // Procurement
            "4.0": { duration: 10 },
            "4.1": { duration: 5 },
            "4.2": { duration: 20 },
            "4.3": { duration: 30 },
            "4.4": { duration: 25 },
            "4.5": { duration: 20 },
            "4.6": { duration: 20 },

            // Site Mobilization
            "5.0": { duration: 2 },
            "5.1": { duration: 2 },
            "5.2": { duration: 2 },
            "5.3": { duration: 2 },

            // Civil Works
            "6.0": { duration: 4 },
            "6.1": { duration: 4 },
            "6.2": { duration: 4 },
            "6.3": { duration: 4 },
            "6.4": { duration: 4 },

            // Mounting Structure Installation
            "7.0": { duration: 3 },
            "7.1": { duration: 10 },
            "7.2": { duration: 5 },
            "7.3": { duration: 5 },

            // Module Installation
            "8.0": { duration: 3 },
            "8.1": { duration: 10 },
            "8.2": { duration: 5 },
            "8.3": { duration: 3 },

            // DC Cabling & String Formation
            "9.0": { duration: 5 },
            "9.1": { duration: 3 },
            "9.2": { duration: 3 },
            "9.3": { duration: 3 },

            // Inverter and AC Works
            "10.0": { duration: 5 },
            "10.1": { duration: 5 },
            "10.2": { duration: 3 },
            "10.3": { duration: 5 },
            "10.4": { duration: 5 },

            // SCADA and Communication
            "11.0": { duration: 3 },
            "11.1": { duration: 3 },
            "11.2": { duration: 3 },
            "11.3": { duration: 3 },

            // Testing & Commissioning
            "12.0": { duration: 5 },
            "12.1": { duration: 5 },
            "12.2": { duration: 2 },
            "12.3": { duration: 3 },

            // Handover & Documentation
            "13.0": { duration: 3 },
            "13.1": { duration: 3 },
            "13.2": { duration: 3 },
            "13.3": { duration: 1 }
        }
    },
};

const TaskForm = () => {
    const [formData, setFormData] = useState({});
    const [projectDetails, setProjectDetails] = useState(null);
    const [loadingProject, setLoadingProject] = useState(true);
    const [loadingTasks, setLoadingTasks] = useState(true);
    const [saving, setSaving] = useState(false);
    const [modifiedTasks, setModifiedTasks] = useState({});
    const location = useLocation();
    const { projectId, projectType = 'groundmount', country = '' } = location.state || {};
    const token = localStorage.getItem("token");
    sessionStorage.setItem('country', country);
    const finalCountry = sessionStorage.getItem('country')?.toLowerCase() || 'india';


    const calculateEndDate = (startDate, duration) => {
        if (!startDate || !duration) return null;
        return dayjs(startDate).add(parseInt(duration) - 0, 'day');
    };


    // Fetch project details
    useEffect(() => {
        const fetchProjectDetails = async () => {
            if (!projectId) {
                message.error('Project ID not provided');
                setLoadingProject(false);
                return;
            }
            try {
                const response = await fetch(buildApiUrl(`/api/projects/${projectId}`), {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json',
                    },
                });

                if (!response.ok) throw new Error(`Failed to fetch project details: ${response.statusText}`);

                const projectData = await response.json();
                if (projectData.status === 'success') {
                    setProjectDetails(projectData.data);
                }
            } catch (error) {
                console.error('Error fetching project details:', error);
                message.error('Failed to load project details');
            } finally {
                setLoadingProject(false);
            }
        };

        fetchProjectDetails();
    }, [projectId, token]);


    useEffect(() => {
        const fetchTasks = async () => {
            if (!projectId || !projectDetails || !projectType) {
                setLoadingTasks(false);
                return;
            }

            try {
                const response = await fetch(buildApiUrl(`/api/projects/${projectId}/tasks`), {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json',
                    },
                });

                if (!response.ok) throw new Error(`Failed to fetch tasks: ${response.statusText}`);

                const tasksData = await response.json();
                if (tasksData.status === 'success') {
                    const apiTasks = tasksData.data || [];
                    const taskList = getTasksForType(projectType);
                    const newFormData = {};
                    // Sort tasks by srNo numeric value
                    const sortedTaskList = [...taskList].sort((a, b) => parseFloat(a.srNo) - parseFloat(b.srNo));

                    sortedTaskList.forEach(task => {
                        // match srNo with updated dictionary
                        const apiTask = apiTasks.find(t => t.srNo === task.srNo);
                        const taskDuration = TASK_DURATIONS[projectType][finalCountry][task.srNo]?.duration || 0;
                        // Prefill budgetedQty=500 if API doesn't provide, completedQty=0 if not provided
                        newFormData[task.key] = {
                            ...task,
                            duration: taskDuration,
                            plannedStartDate: apiTask?.plannedStartDate ? dayjs(apiTask.plannedStartDate) : null,
                            plannedEndDate: apiTask?.plannedEndDate ? dayjs(apiTask.plannedEndDate) : null,
                            budgetedQty: apiTask?.budgetedQty != null ? apiTask.budgetedQty : projectDetails.projectCapacity || 0,  // default 500
                            completedQty: apiTask?.completedQty != null ? apiTask.completedQty : 0, // default 0
                            actualStartDate: apiTask?.actualStartDate ? dayjs(apiTask.actualStartDate) : null,
                            actualEndDate: apiTask?.actualEndDate ? dayjs(apiTask.actualEndDate) : null,
                            progress: apiTask?.progressPercentage || 0,
                            remarks: apiTask?.remarks || '',
                            _id: apiTask?._id || null
                        };
                    });
                    // If no tasks exist and project has a start date, prefill
                    if (projectDetails?.projectStartDate) {
                        const pStart = dayjs(projectDetails.projectStartDate);

                        // Group tasks by integer section
                        const tasksBySection = {};
                        sortedTaskList.forEach(tObj => {
                            const sectionNum = Math.floor(parseFloat(tObj.srNo));
                            if (!tasksBySection[sectionNum]) {
                                tasksBySection[sectionNum] = [];
                            }
                            tasksBySection[sectionNum].push(tObj);
                        });

                        // Sort sections numerically
                        const sortedSections = Object.keys(tasksBySection).sort((a, b) => parseFloat(a) - parseFloat(b));

                        let runningDate = pStart;

                        // Process each section in order
                        sortedSections.forEach(sectionNum => {
                            // Sort tasks within section numerically (handles both 1.1 and 1.10 correctly)
                            const tasksArr = tasksBySection[sectionNum].sort((a, b) => {
                                const aParts = a.srNo.split('.').map(Number);
                                const bParts = b.srNo.split('.').map(Number);

                                // Compare section numbers
                                if (aParts[0] !== bParts[0]) return aParts[0] - bParts[0];

                                // Compare task numbers within section
                                return aParts[1] - bParts[1];
                            });

                            let sectionStartDate = null;
                            let sectionEndDate = null;

                            // First pass - set dates for all tasks except .0 headers
                            tasksArr.forEach(tObj => {
                                if (tObj.srNo.endsWith('.0')) {
                                    return; // Skip section headers for now
                                }

                                const tData = newFormData[tObj.key];
                                if (!tData.plannedStartDate) {
                                    tData.plannedStartDate = runningDate;
                                    if (tData.duration) {
                                        tData.plannedEndDate = calculateEndDate(runningDate, tData.duration);
                                    }
                                }

                                // Track section dates
                                if (tObj.srNo.endsWith('.1')) {
                                    sectionStartDate = tData.plannedStartDate;
                                }
                                sectionEndDate = tData.plannedEndDate;

                                if (tData.plannedEndDate) {
                                    runningDate = dayjs(tData.plannedEndDate).add(0, 'day');
                                }
                                newFormData[tObj.key] = tData;
                            });

                            // Set dates for section header (.0 task)
                            const sectionHeader = tasksArr.find(t => t.srNo.endsWith('.0'));
                            if (sectionHeader) {
                                newFormData[sectionHeader.key] = {
                                    ...newFormData[sectionHeader.key],
                                    plannedStartDate: sectionStartDate,
                                    plannedEndDate: sectionEndDate
                                };
                            }
                        });
                    }
                    setFormData(newFormData);
                }
            } catch (error) {
                console.error('Error fetching tasks:', error);
                message.error('Failed to load tasks');
            } finally {
                setLoadingTasks(false);
            }
        };

        fetchTasks();
    }, [projectId, projectType, projectDetails, token, finalCountry]);



    const handleDateChange = (name, date, taskKey) => {
        const formattedDate = date ? dayjs(date).format('YYYY-MM-DD') : null;
        const currentTask = formData[taskKey];
        if (!currentTask) return;

        const currentSection = Math.floor(parseFloat(currentTask.srNo));

        setFormData(prev => {
            const updatedFormData = { ...prev };
            updatedFormData[taskKey] = {
                ...updatedFormData[taskKey],
                [name]: date
            };


            if (name === 'plannedStartDate' && date) {
                const duration = TASK_DURATIONS[projectType][finalCountry][currentTask.srNo]?.duration || 0;
                if (duration) {
                    updatedFormData[taskKey].plannedEndDate = calculateEndDate(date, duration);

                    // Get all tasks in the current section and sort them properly
                    const sectionTasks = Object.values(updatedFormData)
                        .filter(t => Math.floor(parseFloat(t.srNo)) === currentSection)
                        .sort((a, b) => {
                            // Proper numeric sort for version numbers (e.g., 1.1, 1.2, 1.10)
                            const aParts = a.srNo.split('.').map(Number);
                            const bParts = b.srNo.split('.').map(Number);

                            // Compare section numbers first
                            if (aParts[0] !== bParts[0]) return aParts[0] - bParts[0];
                            // Then compare task numbers
                            return aParts[1] - bParts[1];
                        });

                    // Find the index of the current task
                    const currentIndex = sectionTasks.findIndex(t => t.key === taskKey);

                    // Update all subsequent tasks in the section
                    for (let i = currentIndex + 1; i < sectionTasks.length; i++) {
                        const nextTask = sectionTasks[i];
                        const prevTask = sectionTasks[i - 1];

                        if (prevTask?.plannedEndDate) {
                            const nextDur = TASK_DURATIONS[projectType][finalCountry][nextTask.srNo]?.duration || 0;
                            const newStartDate = dayjs(prevTask.plannedEndDate).add(1, 'day');

                            updatedFormData[nextTask.key] = {
                                ...updatedFormData[nextTask.key],
                                plannedStartDate: newStartDate,
                                plannedEndDate: nextDur ? calculateEndDate(newStartDate, nextDur) : null
                            };
                        }
                    }
                }
            }
            return updatedFormData;
        });

        setModifiedTasks(prev => ({
            ...prev,
            [taskKey]: {
                ...prev[taskKey],
                [name]: formattedDate
            }
        }));
    };

    const handleInputChange = (e, taskKey) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [taskKey]: {
                ...prev[taskKey],
                [name]: value
            }
        }));

        setModifiedTasks(prev => ({
            ...prev,
            [taskKey]: {
                ...prev[taskKey],
                [name]: value
            }
        }));
    };


    const handleSaveChanges = async () => {
        if (!projectId) {
            message.error('Project ID not provided');
            return;
        }
        if (Object.keys(modifiedTasks).length === 0) {
            message.info('No changes to save');
            return;
        }

        setSaving(true);
        const loadingMessage = message.loading('Saving changes...', 0);

        try {
            const updatePromises = [];
            const newTasksPayload = [];
            const additionalModifiedTasks = {};


            Object.entries(modifiedTasks).forEach(([taskKey]) => {
                const task = formData[taskKey];
                if (!task) return;

                const payload = {
                    srNo: task.srNo,
                    taskDetails: task.name,
                    duration: task.duration,
                    plannedStartDate: task.plannedStartDate
                        ? dayjs(task.plannedStartDate).format('YYYY-MM-DD')
                        : null,
                    plannedEndDate: task.plannedEndDate
                        ? dayjs(task.plannedEndDate).format('YYYY-MM-DD')
                        : null,
                    budgetedQty: task.budgetedQty,
                    completedQty: task.completedQty,
                    actualStartDate: task.actualStartDate
                        ? dayjs(task.actualStartDate).format('YYYY-MM-DD')
                        : null,
                    actualEndDate: task.actualEndDate
                        ? dayjs(task.actualEndDate).format('YYYY-MM-DD')
                        : null,
                    progressPercentage: task.progress,
                    remarks: task.remarks
                };

                // Handle .0 tasks that derive plannedStartDate & plannedEndDate
                if (task.srNo.endsWith('.0')) {
                    const sectionTasks = Object.values(formData).filter(t =>
                        t.srNo.startsWith(task.srNo.split('.')[0] + '.')
                    );

                    const firstTask = sectionTasks.find(t => t.srNo.endsWith('.1'));
                    const lastTask = sectionTasks[sectionTasks.length - 1];

                    if (firstTask && firstTask.plannedStartDate) {
                        payload.plannedStartDate = dayjs(firstTask.plannedStartDate).format('YYYY-MM-DD');
                    }
                    if (lastTask && lastTask.plannedEndDate) {
                        payload.plannedEndDate = dayjs(lastTask.plannedEndDate).format('YYYY-MM-DD');
                    }

                    additionalModifiedTasks[taskKey] = true;
                }

                if (task._id) {
                    updatePromises.push(
                        fetch(buildApiUrl(`/api/projects/${projectId}/tasks/${task._id}`), {
                            method: 'PUT',
                            headers: {
                                'Authorization': `Bearer ${token}`,
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify(payload),
                        }).then(response => {
                            if (!response.ok) throw new Error(`Failed to update task ${task.name}`);
                            return response.json();
                        })
                    );
                } else {
                    newTasksPayload.push(payload);
                }
            });


            Object.entries(additionalModifiedTasks).forEach(([taskKey]) => {
                if (!modifiedTasks[taskKey]) {
                    modifiedTasks[taskKey] = true;
                }
            });

            // Process updates
            if (updatePromises.length > 0) {
                await Promise.all(updatePromises);
            }

            // Process new tasks
            if (newTasksPayload.length > 0) {
                const response = await fetch(
                    buildApiUrl(`/api/projects/${projectId}/tasks`), {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(newTasksPayload),
                });

                if (!response.ok) {
                    throw new Error('Failed to create new tasks');
                }

                const createdTasks = await response.json();
                createdTasks.data.tasks.forEach((newTask) => {
                    const matchingKey = Object.keys(formData).find(
                        key => formData[key].srNo === newTask.srNo
                    );
                    if (matchingKey) {
                        setFormData(prev => ({
                            ...prev,
                            [matchingKey]: {
                                ...prev[matchingKey],
                                _id: newTask._id
                            }
                        }));
                    }
                });
            }

            loadingMessage();
            message.success('All changes saved successfully');
            setModifiedTasks({});
        } catch (error) {
            loadingMessage();
            console.error('Error saving changes:', error);
            message.error('Failed to save changes');
        } finally {
            setSaving(false);
        }
    };



    // Render sections
    const renderSection = (sectionNumber) => {
        const tasksInSection = getTasksForType(projectType).filter(
            task => Math.floor(parseFloat(task.srNo)) === sectionNumber
        );

        return (
            <tbody key={sectionNumber}>
                {tasksInSection.map(task => renderTask(task, tasksInSection))}
            </tbody>
        );
    };

    const renderTask = (task, tasksInSection) => {
        const taskData = formData[task.key] || {};
        let plannedStartDate = taskData.plannedStartDate ? dayjs(taskData.plannedStartDate) : null;
        let plannedEndDate = taskData.plannedEndDate ? dayjs(taskData.plannedEndDate) : null;
        const isSubHeading = task.srNo.endsWith('.0');

        if (isSubHeading) {
            // Find the .1 task for plannedStartDate
            const firstTask = tasksInSection.find(t => t.srNo.endsWith('.1'));
            if (firstTask) {
                plannedStartDate = formData[firstTask.key]?.plannedStartDate
                    ? dayjs(formData[firstTask.key].plannedStartDate)
                    : null;
            }


            const lastTask = tasksInSection[tasksInSection.length - 1];
            if (lastTask) {
                plannedEndDate = formData[lastTask.key]?.plannedEndDate
                    ? dayjs(formData[lastTask.key].plannedEndDate)
                    : null;
            }
        }

        let rowClasses = "bg-white";
        let inputClasses = "bg-white";

        if (/^\d+\.0$/.test(task.srNo)) {
            const sectionIndex = parseInt(task.srNo.split('.')[0]);


            const colorMap = [
                "bg-yellow-100",
                "bg-green-100",
                "bg-red-100",
                "bg-blue-100",
                "bg-purple-100",
                "bg-pink-100",
                "bg-orange-100",
                "bg-teal-100",
                "bg-indigo-100",
                "bg-lime-100",
            ];


            const color = colorMap[sectionIndex % colorMap.length];

            rowClasses = color;
            inputClasses = color;
        } else {
            rowClasses = "bg-white";
            inputClasses = "bg-white";
        }



        return (
            <tr key={task.key} className={`text-[12px]  font-medium border-b border-gray-300 ${rowClasses}`}>
                <td className="px-1 py-1 text-center">{task.srNo}</td>
                <td className="px-1 py-1">{task.name}</td>
                <td className="px-1 py-1 text-center">
                    {taskData.duration ?? 0}
                </td>
                <td className="px-1 py-1 text-center">
                    <DatePicker
                        value={plannedStartDate}
                        onChange={(date) => handleDateChange('plannedStartDate', date, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                        placeholder=""
                        format="DD-MM-YYYY"
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <DatePicker
                        value={plannedEndDate}
                        onChange={(date) => handleDateChange('plannedEndDate', date, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                        placeholder=""
                        format="DD-MM-YYYY"
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <Input
                        type="number"
                        name="budgetedQty"
                        value={taskData.budgetedQty}
                        onChange={(e) => handleInputChange(e, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <Input
                        type="number"
                        name="completedQty"
                        value={taskData.completedQty}
                        onChange={(e) => handleInputChange(e, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <DatePicker
                        value={taskData.actualStartDate}
                        onChange={(date) => handleDateChange('actualStartDate', date, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                        placeholder=""
                        format="DD-MM-YYYY"
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <DatePicker
                        value={taskData.actualEndDate}
                        onChange={(date) => handleDateChange('actualEndDate', date, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                        placeholder=""
                        format="DD-MM-YYYY"
                    />
                </td>
                <td className="px-1 py-1 text-center">
                    <Input
                        type="number"
                        name="progress"
                        value={taskData.progress}
                        onChange={(e) => handleInputChange(e, task.key)}
                        min="0"
                        max="100"
                        className={`w-full border-none ${inputClasses}`}
                    />
                </td>
                <td className="px-1 py-1">
                    <Input
                        name="remarks"
                        value={taskData.remarks}
                        onChange={(e) => handleInputChange(e, task.key)}
                        className={`w-full border-none ${inputClasses}`}
                    />
                </td>
            </tr >
        );
    };



    if (loadingProject || loadingTasks) {
        return (
            <div className="w-full min-h-screen flex justify-center items-center bg-gray-200">
                <Spin size="large" tip="Loading data..." />
            </div>
        );
    }

    // Unique sections
    const sections = Array.from(
        new Set(
            getTasksForType(projectType).map(task =>
                Math.floor(parseFloat(task.srNo))
            )
        )
    ).sort((a, b) => a - b);

    return (
        <div className='flex flex-row'>
            <Sidebar />
            <div className="w-full min-h-screen flex">
                <div className="w-full h-full bg-white shadow-lg rounded-lg p-6">
                    <div className="mb-4 flex flex-row justify-between">
                        <Link to="/">
                            <Button type="default">
                                &larr; Back to Project List
                            </Button>
                        </Link>
                        <p className="text-gray-600 text-[14px]">
                            Last Updated: {projectDetails?.updateDate
                                ? dayjs(projectDetails.updateDate).format('DD-MM-YYYY HH:mm')
                                : ''
                            }
                        </p>
                    </div>
                    <div className="w-full border-b border-gray-300 mb-6"></div>

                    <div className="grid grid-cols-3 gap-6 mb-6">
                        {[
                            {
                                title: "Project Info",
                                value: `${projectDetails?.projectName || '-'}`,
                                sub: projectDetails?.projectType
                                    ? projectDetails.projectType.charAt(0).toUpperCase() + projectDetails.projectType.slice(1)
                                    : '-',
                            },
                            {
                                title: "Total Capacity",
                                value: `${projectDetails?.projectCapacity || '-'} ${projectDetails?.capacityUnit || ''}`,
                                sub: "+2.15% from last month",
                                color: "text-green-500",
                            },
                            {
                                title: "Overall Progress",
                                value: `${Math.round(projectDetails?.overallProgress || 0)}%`,
                                sub: "+2.15% from last month",
                                color: "text-green-500",
                            },
                        ].map((item, idx, arr) => (
                            <div
                                key={idx}
                                className={`pr-6 ${idx !== arr.length - 1 ? "border-r border-gray-300" : ""} flex flex-col items-center text-center`}
                            >
                                <p className="text-sm text-[black] mb-1">{item.title}</p>
                                <h2 className="text-2xl font-bold text-[#0D2B52]">{item.value}</h2>
                                {item.sub && (
                                    <p className="text-sm">
                                        <span className={item.color}>{item.sub.split(" ")[0]}</span>{" "}
                                        <span className="text-gray-800">{item.sub.split(" ").slice(1).join(" ")}</span>
                                    </p>
                                )}
                            </div>
                        ))}
                    </div>


                    <div className="w-full border-b border-gray-300 mb-6"></div>

                    <div className="mt-0">
                        <div className='flex flex-row justify-between'>
                            <h1 className='text-[28px] font-semibold'>
                                Task List
                            </h1>
                            <div className="mb-6  flex justify-end">
                                <Button
                                    className={`rounded-[8px] text-white 
    ${Object.keys(modifiedTasks).length === 0
                                            ? '!bg-gray-400 hover:!bg-gray-400 cursor-not-allowed !text-gray-200'
                                            : '!bg-[#0D2B52] hover:!bg-[#173E73] !text-[white]'}
  `}
                                    onClick={handleSaveChanges}
                                    loading={saving}
                                    disabled={Object.keys(modifiedTasks).length === 0}
                                >
                                    Save Changes
                                </Button>

                            </div>
                        </div>
                        <div>
                            <table className="table-auto w-full">
                                <thead>
                                    <tr className="bg-gray-100 text-[13px] border-b border-gray-300">
                                        <th className="px-2 py-2 text-left">Sr. No</th>
                                        <th className="px-2 py-2 text-left">Task Details</th>
                                        <th className="px-2 py-2 text-left">Duration</th>
                                        <th className="px-2 py-2 text-left">Planned Start Date</th>
                                        <th className="px-2 py-2 text-left">Planned End Date</th>
                                        <th className="px-2 py-2 text-left">Budgeted Qty</th>
                                        <th className="px-2 py-2 text-left">Completed Qty</th>
                                        <th className="px-2 py-2 text-left">Actual Start Date</th>
                                        <th className="px-2 py-2 text-left">Actual End Date</th>
                                        <th className="px-2 py-2 text-left">Progress(%)</th>
                                        <th className="px-2 py-2 text-left">Remarks</th>
                                    </tr>
                                </thead>
                                {sections.map(section => renderSection(section))}
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TaskForm;
